// @ts-strict-ignore
import React, { memo, useMemo } from 'react'
import { Dialog, Slide, DialogProps } from '@mui/material'
import { useMediaQuery } from 'hooks/useMediaQuery'

const dialogTransition = props => (<Slide direction="up" {...props} />)

const tallPaperStyle = {
  height: 800,
}

export interface IResponsiveDialogProps extends Omit<DialogProps, 'open' | 'fullScreen'> {
  maxFullscreenWidth?: string
  fullWidth?: boolean
  tall?: boolean
  children?: any
  open: boolean
}

function ResponsiveDialog(props: IResponsiveDialogProps) {
  const {
    children,
    maxFullscreenWidth = '750px',
    fullWidth = false,
    open,
    scroll = 'body',
    tall,
    PaperProps,
    TransitionComponent,
    ...restProps
  } = props

  const fullScreen = useMediaQuery(`(max-width:${maxFullscreenWidth})`)

  const paperPropsCombined = useMemo(() => {
    const combined = {
      ...PaperProps,
      style: {
        ...PaperProps?.style,
        overflowX: 'hidden' as const,
      },
      ...props.PaperProps,
    }

    if (tall) {
      combined.style = {
        ...combined.style,
        ...tallPaperStyle,
      }
    }

    return combined
  }, [PaperProps, props.PaperProps, tall])

  const transition = useMemo(() => (
    !fullScreen || TransitionComponent ? TransitionComponent : dialogTransition
  ), [fullScreen, TransitionComponent])

  // TODO: slap a EventPropagationBlocker? We have dialogs where the click events leak to the underlying table
  return (
    <Dialog
      {...restProps}
      open={open}
      fullScreen={fullScreen}
      // TODO fix transition animation for production build
      // this prop produced issues with rerendering modal in production build
      // TransitionComponent={transition}
      scroll={fullScreen ? 'paper' : scroll} // forcing 'paper' in fullscreen mode fixes buttons not being placed at the bottom of the dialog
      PaperProps={paperPropsCombined}
    >
      {fullWidth && (
        // spanner
        <div style={{ width: 9999 }} />
      )}

      {children}
    </Dialog>
  )
}

export default memo(ResponsiveDialog)
